module.exports = __webpack_public_path__ + "static/d3829e.jpg";